import React, { useContext, useState } from 'react';
import { FilterContext } from './Context';

const Filters = () => {
    const {creditTypeFilter, setCreditTypeFilter, projectTypeFilter, setProjectTypeFilter} = useContext(FilterContext);
    const [localCreditFilter, setLocalCreditFilter] = useState(creditTypeFilter);
    const [localProjectFilter, setLocalProjectFilter] = useState(projectTypeFilter);

    const filterResults = (e) => {
        e?.preventDefault();
        setCreditTypeFilter(localCreditFilter);
        setProjectTypeFilter(localProjectFilter);
    }

    return (
        <div className="filter-bar">
            <a className="all-projects-link" href="/impact-projects/">&lt; Browse All Projects</a>

            <div className="flex flex-wrap flex-space-between flex-align-center">
                <div className="flex-col flex-col-auto">
                    <h1 className="filter-bar-title">Project Map</h1>
                </div>
                
                <div className="flex-col flex-col-auto">
                    <div className="flex flex-wrap flex-tiny-gutters">
                        <div className="flex-col">
                            <select name="credit_type" className="input input-black input-sm" value={localCreditFilter} onChange={(e) => setLocalCreditFilter(e.target.value)}>
                                <option value="" hidden="">Filter by Credit</option>
                                <option value="">All</option>
                                <option value="federal"> Federal</option>
                                <option value="state"> State</option>
                            </select>
                        </div>

                        <div className="flex-col flex-col-auto">
                            <select name="project_type" className="input input-black input-sm" value={localProjectFilter} onChange={(e) => setLocalProjectFilter(e.target.value)}>
                                <option value="" hidden="">Filter by Project</option>
                                <option value="">All</option>
                                <option value="affordable-housing"> Affordable Housing</option>
                                <option value="renewable-energy"> Renewable Energy</option>
                                <option value="historic-rehabilitation"> Historic Rehabilitation</option>
                            </select>
                        </div>

                        <div className="flex-col flex-col-auto">
                            <button className="button button-orange-fill button-full-height button-sm button-full-width" type="submit" onClick={filterResults}>
                                <span className="icon icon-filters"></span>
                                <span>Filter</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Filters;